"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Device = _interopRequireDefault(require("@rsuite/icon-font/lib/device/Device"));

// Generated by script, don't edit it please.
var Device = (0, _createSvgIcon["default"])({
  as: _Device["default"],
  ariaLabel: 'device',
  category: 'device',
  displayName: 'Device'
});
var _default = Device;
exports["default"] = _default;
module.exports = exports.default;